import BuildingInfoLayouts from './BuildingInfoLayout';

export default BuildingInfoLayouts;
